const styles = {
  flex: { flex: 1 },
  width: '100%',
  backgroundColor: 'transparent !important',
  appHeader: { position: 'relative', marginTop: 0, backgroundColor: 'transparent !important' },
};

export default styles;



// WEBPACK FOOTER //
// ./src/containers/seats/common/seatSelection/SeatSelectionHeaderStyles.js